import {
    CONFIRMED_GET_UNIT_DOSES,
    CONFIRMED_CREATE_UNIT_DOSE,
    CONFIRMED_DELETE_UNIT_DOSE,
    CONFIRMED_EDIT_UNIT_DOSE,
  } from "../types/UnitOfDoseTypes";
  
  import {
    getUnitOfDoses,
    createUnitOfDose,
    updateUnitOfDose,
    deleteUnitOfDose,
    formatUnitOfDoses,
  } from "../../services/UnitOfDoseService";
  
  import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
  
  // Get Unit of Doses
  export function getUnitOfDoseAction(
    pagination = true,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = ""
  ) {
    return async (dispatch) => {
      try {
        const response = await getUnitOfDoses(
          pagination,
          pageid,
          search_by,
          search_keyword,
          sort_by,
          sort_order
        );
  
        if (response?.status === 200 && response.data?.status === "success") {
          const units = formatUnitOfDoses(response.data.data);
          const num_rows = response.data.num_rows || 0;
  
          dispatch({
            type: CONFIRMED_GET_UNIT_DOSES,
            payload: { units, num_rows },
          });
        } else {
          handleError("Failed to get unit of doses");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to get unit of doses");
      }
    };
  }
  
  // Delete Unit of Dose
  export function deleteUnitOfDoseAction(unitDoseId) {
    return async (dispatch) => {
      try {
        await deleteUnitOfDose(unitDoseId);
        dispatch({
          type: CONFIRMED_DELETE_UNIT_DOSE,
          payload: { unit_dose_id: unitDoseId },
        });
        handleSuccess("Unit of Dose deleted successfully!");
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to delete unit of dose");
      }
    };
  }
  
  // Create Unit of Dose
  export function createUnitOfDoseAction(unitDoseData, navigate) {
    return async (dispatch) => {
      try {
        const response = await createUnitOfDose(unitDoseData);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formattedUnit = formatUnitOfDoses([response.data.data])[0];
          dispatch({
            type: CONFIRMED_CREATE_UNIT_DOSE,
            payload: formattedUnit,
          });
          if (navigate) navigate("/app-unit-of-dose");
          handleSuccess("Unit of Dose created successfully!");
        } else {
          showErrorAlert("Failed to create unit of dose");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to create unit of dose");
      }
    };
  }
  
  // Update Unit of Dose
  export function updateUnitOfDoseAction(unitDoseData, unitDoseId, navigate) {
    return async (dispatch) => {
      try {
        const payload = {
          ...unitDoseData,
          unit_dose_id: unitDoseId,
        };
  
        const response = await updateUnitOfDose(payload);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formattedUnit = formatUnitOfDoses([response.data.data])[0];
          dispatch({
            type: CONFIRMED_EDIT_UNIT_DOSE,
            payload: formattedUnit,
          });
          if (navigate) navigate("/app-unit-of-dose");
          handleSuccess("Unit of Dose updated successfully!");
        } else {
          showErrorAlert("Failed to update unit of dose");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to update unit of dose");
      }
    };
  }
  